var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"line-height":"0"},style:({ fontSize: _vm.size + 'px' })},[_c(_vm.selectedIcon,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }